// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme, borderRadius, outlinedFilled) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: '#fafafa',
          borderRadius: `${borderRadius || 10}px`,
          transition: 'all 0.2s ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[300],
            borderWidth: '1px'
          },
          '&:hover': {
            backgroundColor: '#fff',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(102, 126, 234, 0.4)'
            }
          },
          '&.Mui-focused': {
            backgroundColor: '#fff',
            boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#667eea',
              borderWidth: '2px'
            }
          },
          '&.MuiInputBase-multiline': {
            padding: 1
          }
        },
        input: {
          fontWeight: 400,
          padding: '14px 16px',
          fontSize: '0.9375rem',
          '&.MuiInputBase-inputSizeSmall': {
            padding: '10px 14px',
            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0
            }
          }
        },
        inputAdornedStart: {
          paddingLeft: 4
        },
        notchedOutline: {
          borderRadius: `${borderRadius || 10}px`
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'rgba(102, 126, 234, 0.4)'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#667eea',
              borderWidth: '2px'
            }
          }
        }
      }
    }
  };
}
